import { render, staticRenderFns } from "./Simple.vue?vue&type=template&id=6567e0a2&scoped=true"
import script from "./Simple.vue?vue&type=script&lang=js"
export * from "./Simple.vue?vue&type=script&lang=js"
import style0 from "./Simple.vue?vue&type=style&index=0&id=6567e0a2&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6567e0a2",
  null
  
)

export default component.exports